<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
  >
    <template v-slot:activator="{ props }">
      <slot name="activator" v-bind="{ props }" />
    </template>

    <v-form ref="form" data-cy="podMenu-tools-saveFrame-form">
      <v-card >
        <v-card-title class="d-flex justify-space-between">
          <span>{{$t('routes.pod.menuSaveFrame.saveFrame')}}</span>
          <v-btn icon @click="dialog = false" :aria-label="$t('common.close')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="scrollable mt-4 pt-4">
          <div class="mb-4 d-flex">
            <div class="text-right d-flex align-center" style="width: 20%;">
              {{$t('routes.pod.menuSaveFrame.time')}}
            </div>

            <div style="width: 45%;">
              <v-text-field
                v-bind:model-value="playerTimeFormatted"
                v-bind:placeholder="$t('routes.pod.menuSaveFrame.time')"
                variant="solo-filled"
                hide-details="auto"
                data-cy="podMenu-tools-saveFrame-playerTime"
                readonly disabled block flat
              >
              </v-text-field>
            </div>

          </div>

          <div v-show="successMessage" class="bg-success"
               data-cy="podMenu-tools-saveFrame-successMessage">{{ successMessage }}
          </div>
          <div v-show="errorMessage" class="bg-error"
               data-cy="podMenu-tools-saveFrame-errorMessage">{{ errorMessage }}
          </div>
          <UtilityPodsErrors data-cy="podMenu-tools-saveFrame-utilityPodsError" />
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            v-on:click.prevent="saveFrame"
            v-bind:disabled="isSubmitDisabled"
            color="primary"
            variant="flat"
            data-cy="podMenu-tools-saveFrame-save-btn"
          >
            {{$t('routes.pod.menuSaveFrame.saveFrame')}}
          </v-btn>

          <v-btn variant="text" @click="dialog = false">{{$t('common.close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

  </v-dialog>
</template>

<script>
import { usePlayerStore } from '@/stores/PlayerStore.js'
import { useServiceStore } from '@/stores/ServiceStore.js'
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import { toTimeMilliseconds, toTimeMillisecondsFull } from '@/components/formatters.js';
import DialogModel from '@/components/mixin/DialogModel.js';

export default {
  mixins: [DialogActionKeys, DialogModel],
  name: "SaveFrameDialog",
  props: {
    pod: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      successMessage: "",
      errorMessage: "",
      serviceActivated: false,
    };
  },
  watch: {
    dialog(newValue) {
      if (newValue) {
        this.updatePodsUtility();
      }

      this.errorMessage = '';
      this.successMessage = '';
      this.serviceActivated = false;
    },
  },
  methods: {
    updatePodsUtility: function() {
      if (!this.getExtractFramesService) {
        this.errorMessage = "Extract-frames service not found!";
        return;
      }

      let utilityPayload = {
        serviceAlias: this.getExtractFramesService.alias,
        pods: [this.pod],
      }

      const serviceStore = useServiceStore();
      return serviceStore.updatePodsUtility(utilityPayload);
    },
    saveFrame: function() {
      this.errorMessage = "";
      this.successMessage = "";
      let self = this;

      this.updatePodsUtility()
      .then(function() {
        const serviceStore = useServiceStore();
        const runnable = serviceStore.getRunnablePods;

        if (runnable.length === 0) {
          throw { response: { data: { error: { message: self.$t("routes.pod.menuSaveFrame.operationError")}}}}
        }

        let payload = {
          serviceAlias: self.getExtractFramesService.alias,
          utilityPods: runnable,
          params: {
            time: self.playerTimeMilliseconds,
            frames: 1
          }
        }

        return serviceStore.runService(payload)
      })
      .then(function() {
        if (self.utilityPodsErrors.length === 0) {
          self.successMessage = self.$t("routes.pod.menuSaveFrame.frameWillBeSaved");
        }

        self.serviceActivated = true;
      })
      .catch(function(error) {
        if (error && error.response && error.response.data && error.response.data.error) {
          self.errorMessage = error.response.data.error.message;
        } else {
          self.errorMessage = "Error!";
          console.log(error);   // unhandled error
        }
      });
    }
  },
  computed: {
    playerCURRENTTIME: function() {
      const playerStore = usePlayerStore();
      return playerStore.currentTime;
    },
    playerTimeFormatted: function() {
      return toTimeMilliseconds(this.playerCURRENTTIME)
    },
    playerTimeMilliseconds: function() {
      return toTimeMillisecondsFull(this.playerCURRENTTIME);
    },
    getExtractFramesService: function() {
      const serviceStore = useServiceStore();
      return serviceStore.getExtractFrames;
    },
    utilityPodsErrors: function() {
      const serviceStore = useServiceStore();
      return serviceStore.getUtilityPodsErrors;
    },
    isSubmitDisabled: function() {
      return this.utilityPodsErrors.length > 0 ||
        this.serviceActivated === true;
    },
  }
}
</script>

<style>
</style>
